import { useEffect, useId, useRef } from 'react'
import { useNavigate } from 'react-router'

import { pushBackButtonEntry, removeBackButtonEntry, updateBackButtonEntry } from './stack'

export type BackButtonProps = {
  onPress?: () => void
}

/**
 * Декларативный BackButton (docs/telegram.md §2). Если onPress не передан —
 * сам вызывает navigate(-1). При нескольких смонтированных выигрывает последний.
 */
export function BackButton(props: BackButtonProps) {
  const { onPress } = props
  const id = useId()
  const navigate = useNavigate()

  const resolvedOnPressRef = useRef<() => void>(() => {})
  resolvedOnPressRef.current = onPress ?? (() => navigate(-1))

  useEffect(() => {
    pushBackButtonEntry({ id, onPress: () => resolvedOnPressRef.current() })
    return () => removeBackButtonEntry(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  useEffect(() => {
    updateBackButtonEntry(id, () => resolvedOnPressRef.current())
  }, [id, onPress])

  return null
}
